import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const BillBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { close } = useCommands();
    const { selectedBillCount = 0, onBillBulkCreateTask } = options;

    const heading = `${pluralizeWithCount("bill", selectedBillCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onBillBulkCreateTask && (
                <CommandItem
                    keywords={["task", "create"]}
                    onSelect={() => {
                        close();
                        onBillBulkCreateTask();
                    }}
                    shortcut="t"
                >
                    Create task
                </CommandItem>
            )}
        </Command.Group>
    );
};
